import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { COMPONENT_NAME } from '../../../constants';
import FormSetup from '../../../components/cms/admin/accounts/EnrichmentRule/FormSetup';
import CentralizedPerson from '../../../components/cms/admin/accounts/EnrichmentRule/retrieve/CentralizedPerson';
import PersonIdentifier from '../../../components/cms/admin/accounts/EnrichmentRule/retrieve/PersonIdentifier';
import CentralizedCompany from '../../../components/cms/admin/accounts/EnrichmentRule/retrieve/CentralizedCompany';
import CompanyIdentifier from '../../../components/cms/admin/accounts/EnrichmentRule/retrieve/CompanyIdentifier';

const ContentChild = () => {
    const { component, attributes } = useSelector((state) => state.admin.flexibleModal);

    const getComponentFlexibleModal = useCallback(() => {
        switch (component) {
            case COMPONENT_NAME.ADMIN_PIXEL_RULE:
                return <FormSetup attributes={attributes} />;
            case COMPONENT_NAME.ADMIN_CENTRALIZED_PERSON:
                return <CentralizedPerson attributes={attributes} />;
            case COMPONENT_NAME.ADMIN_PERSON_IDENTIFIER:
                return <PersonIdentifier attributes={attributes} />;
            case COMPONENT_NAME.ADMIN_CENTRALIZED_COMPANY:
                return <CentralizedCompany attributes={attributes} />;
            case COMPONENT_NAME.ADMIN_COMPANY_IDENTIFIER:
                return <CompanyIdentifier attributes={attributes} />;
            default:
                return <></>;
        }
    }, [component, attributes]); // eslint-disable-line react-hooks/exhaustive-deps

    return <>{getComponentFlexibleModal()}</>;
};
export default ContentChild;
